import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import HeroSection from './components/HeroSection';
import ClientLogos from './components/ClientLogos';
import FeaturesSection from './components/FeaturesSection';
import TestimonialsSection from './components/TestimonialsSection';
import SolutionsSection from './components/SolutionsSection';
import ResourcesSection from './components/ResourcesSection';
import CTASection from './components/CTASection';

const Homepage = () => {
  return (
    <>
      <Helmet>
        <title>PolicyAlerts - Real-Time Medical Policy Monitoring & Alerts</title>
        <meta 
          name="description" 
          content="PolicyAlerts monitors medical policy changes across commercial, Medicare, and Medicaid insurers in real-time. Trusted by provider groups, ENT groups, specialty medicine, and device manufacturers for comprehensive coverage intelligence." 
        />
        <meta name="keywords" content="medical policy monitoring, policy alerts, coverage reports, Medicare policy changes, Medicaid policy tracking, commercial insurance policies, healthcare policy intelligence" />
      </Helmet>

      <div className="min-h-screen bg-white flex flex-col">
        <Header />
        
        <main className="flex-1 pt-16">
          <HeroSection />
          <ClientLogos />
          <FeaturesSection />
          <TestimonialsSection />
          <SolutionsSection />
          <ResourcesSection />
          <CTASection />
        </main>

        <Footer />
      </div>
    </>
  );
};

export default Homepage;